export default {
      id: "ic_plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "images/icons.3.109.2.svg#ic_plus-usage",
      toString: function () {
        return this.url;
      }
    }